import { render, staticRenderFns } from "./result-bmi.vue?vue&type=template&id=523db694&scoped=true&"
import script from "./result-bmi.vue?vue&type=script&lang=js&"
export * from "./result-bmi.vue?vue&type=script&lang=js&"
import style0 from "./result-bmi.vue?vue&type=style&index=0&id=523db694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523db694",
  null
  
)

export default component.exports